import { gtmTracker, GTM_EVENTS } from '../../gtmTracker';
import { addStaticIndication as addStaticIndicationAction } from '../actions';
import NOTIFICATION_TYPES from '../config/notificationTypes';
import createEventViaIndication from './utils';

const addStaticIndication = indication => dispatch => {
    const event = createEventViaIndication(NOTIFICATION_TYPES.STICKY, indication);
    gtmTracker.trackEvent(GTM_EVENTS.NOTIFICATION, event);
    dispatch(addStaticIndicationAction(indication));
};

export default addStaticIndication;
